<script setup lang="ts">
/**
 * @author Alexander Kenchoshvili
 */
import { format } from "date-fns";
// import { ka, enGB, ru } from "date-fns/locale";
import enGB from "date-fns/locale/en-GB/index";
import ka from "date-fns/locale/ka/index";
import ru from "date-fns/locale/ru/index";
import { computed } from "vue";
import { useMainStore } from "@/store/main/index";

import type { ListDataInterface } from "@/types/ContentType";
import getSingleUrl from "@/composables/utils/singleUrl";
const Picture = defineAsyncComponent(
  () => import("@/components/regularComponents/UIComponents/Picture.vue")
);

const mainStore = useMainStore();

const props = defineProps<{
  data: ListDataInterface;
}>();

const devices = computed(() => props?.data?.cover?.[0]?.devices);

const getTime = (time: string | undefined) => {
  if (!time) {
    return;
  }
  return format(new Date(time.slice(0, 10)), "d MMMM yyyy", {
    locale: mainStore.lang === "ka" ? ka : mainStore.lang === "en" ? enGB : ru,
  });
};
</script>

<template>
  <router-link :to="getSingleUrl(data)">
    <div class="news-card">
      <div class="news-card__items">
        <div class="news-card__item d-flex dir-col al-start">
          <div class="news-card__image-wrapper w-full pos-rel ov-hidden">
            <Picture
              class="news-card__image"
              imgClass="img-absolute"
              :devices="devices"
              :alt="data?.title"
            />
          </div>

          <span class="news-card__date hl-4">{{ getTime(data?.date) }}</span>
          <h2 class="news-card__caption hl-3-bold">
            {{ data?.title }}
          </h2>
        </div>
      </div>
    </div>
  </router-link>
</template>

<style lang="scss">
.news-card {
  img {
    @include easeOut(1200ms, all);
  }

  @include hover {
    img {
      transform: scale(1.1);
    }
  }
  &__item {
    margin-bottom: 15px;
    @include maxq(mobile-sm) {
      margin-bottom: 0px;
    }
  }
  &__image-wrapper {
    transition: 0.5s all;
    z-index: 1;
    margin-bottom: 16px;
    &::before {
      content: "";
      display: block;
      padding-top: 65.61181434599156%;
    }
  }

  &__date {
    color: $black;
    margin-bottom: 8px;
    opacity: 0.6;
    @include weight(400);
  }
  &__caption {
    margin-bottom: 8px;
    @include clamp(2);
  }
}
</style>
